import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function Lists() {
    const [lists, setLists] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosPrivate.get("/lists", {headers: {Authorization: "Bearer " + auth.accessToken}});
                setLists(response.data);
            } catch (error) {
                console.error("Error fetching lists:", error);
            }
        };
        fetchData();
    }, [axiosPrivate, auth.accessToken]);

    const navigate = useNavigate();

    return (
        <div className="flex flex-col gap-6">
            <div className="w-full">
                <div className="rounded-lg border border-gray-200 bg-slate-100 p-6 sticky top-6">
                    <div className="flex justify-start items-center gap-4 mb-4">
                        <button onClick={() => navigate("/add-list")} className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600">
                            Add List
                        </button>
                    </div>
                    <p className="text-sm text-gray-500 mb-4"></p>
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                        {lists.length > 0 ? (
                            <div className="overflow-hidden">
                                <div className="max-h-[600px] overflow-y-auto">
                                    <table className="min-w-full">
                                        <thead className="bg-gray-50 sticky top-0 z-10">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    #
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Name
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {lists.map((list, index) => (
                                                <tr id={list.id} key={index} className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        {index + 1}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                        {list.name}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <Link to={`/edit-list/${list.id}`}>Edit</Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-8 text-gray-500">No lists found</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Lists;